import { forwardRef } from "react";
import { mediaSrc } from "@/lib/api";
import { Award, MapPin, Target } from "lucide-react";

// Beautiful, privacy-safe Hunt Card. Shows STATE only — never unit/location or notes.
export const HuntCardView = forwardRef(function HuntCardView({ card }, ref) {
  if (!card) return null;
  const photo = card.photo ? mediaSrc(card.photo) : null;
  return (
    <div ref={ref} className="relative w-full max-w-md mx-auto rounded-2xl overflow-hidden bg-charcoal border border-white/10" data-testid="hunt-card-view">
      <div className="relative aspect-[4/5] bg-gradient-to-b from-forest/40 to-charcoal">
        {photo && <img crossOrigin="anonymous" src={photo} alt={card.species} className="absolute inset-0 w-full h-full object-cover" />}
        <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-black/40" />
        <div className="absolute top-5 left-5 right-5 flex items-center justify-between">
          <span className="hr-overline text-blaze text-[11px]">HomeRange</span>
          {card.harvest && <span className="inline-flex items-center gap-1.5 bg-forest text-bone text-xs font-bold px-3 py-1 rounded-full"><Award size={12} /> HARVEST</span>}
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-6 text-bone">
          {card.year && <span className="text-bone/70 text-sm font-semibold tracking-widest">{card.year}</span>}
          <h2 className="font-serif text-3xl sm:text-4xl leading-tight mt-1">{card.species}</h2>
          <div className="flex items-center gap-4 mt-3 text-sm text-bone/85">
            {card.state && <span className="flex items-center gap-1.5"><MapPin size={13} className="text-blaze" />{card.state}</span>}
            {card.weapon && <span className="flex items-center gap-1.5"><Target size={13} className="text-blaze" />{card.weapon}</span>}
            {card.score && <span className="bg-forest/40 px-2 py-0.5 rounded text-xs font-bold">{card.score}</span>}
          </div>
          {card.story && <p className="text-bone/70 text-sm mt-3 line-clamp-3">{card.story}</p>}
          <p className="text-bone/40 text-xs mt-4">{card.hunter} · homerangehunt.com</p>
        </div>
      </div>
    </div>
  );
});
